export function isTestEnvironment(): boolean {
  const href = window.location.href;
  return href.indexOf("web.dcompany.no") > -1 || href.indexOf("test.dcompany.no") > -1;
}

const prodBaseUrls = ["app.dcompany.no"];

export function isProductionEnvironment(): boolean {
  const href = window.location.href;
  return prodBaseUrls.some((baseUrl) => href.indexOf(baseUrl) > -1);
}
